import React, { useState, useEffect, useMemo } from 'react';
import { useIntl } from 'umi';
import { useMobileOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useMobileOptionList';
import {
  tableDataFormatKMB,
  getCountryNameByCountryCode,
} from '@/pages/intelligence/utils/commonUtils';
import CommonVisualis from '@/pages/intelligence/components/CommonVisualis';
import TipContext from '@home/components/TipContextComponents/TipContext';
import { formatDateStr } from '@intelligence/v3/utils/date';

const RankTrendVisualis = (props: any) => {
  const {
    lineData,
    dateType = 'daily',
    tableSelection,
    trendError,
    loading,
    trendLoading,
    entityType,
    segmentListCur,
    isFreeCur,
    isLineNodata,
    regionOptions,
    appIds,
    segmentValue,
    setSegmentValue,
    handleMetricChangeFun,
    firstWeekSinceReleaseDates = [],
  } = props;
  // console.log('RankTrendVisualis222', props);

  const { formatMessage } = useIntl(); // 中英切换方法

  const lineDataCur = useMemo(() => {
    if (!Array.isArray(lineData) || lineData?.length < 1) return [];
    if (!Array.isArray(tableSelection) || tableSelection?.length < 1) return [];
    const dataList: any = [];
    tableSelection?.forEach((item: any) => {
      const dataObj = lineData?.find((itemSub: any) => itemSub?.market === item?.market);
      dataList.push(dataObj);
    });
    return dataList;
  }, [tableSelection, lineData]);

  const shouldKeepYAxisWhenNoRank = useMemo(() => {
    return isLineNodata && Array.isArray(tableSelection) && tableSelection.length > 0;
  }, [isLineNodata, tableSelection]);

  // 组装rpd折线图数据
  const getHistoryData = (list: any, metricKey = '') => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    const arr: any = [];
    for (const i in list) {
      const metricValue = list[i]?.metrics?.find((item: any) => item?.metric === metricKey)?.value;
      arr.push({
        metric: metricKey,
        source: '',
        time: formatDateStr(list[i]?.time),
        value:
          metricValue === '' || metricValue === null || metricValue === undefined
            ? Number.NaN
            : metricValue,
      });
    }
    const historyTimeSet = new Set(arr.map((item: any) => item?.time));
    firstWeekSinceReleaseDates.forEach((date: string) => {
      const time = formatDateStr(date);
      if (historyTimeSet.has(time)) {
        return;
      }
      arr.push({
        metric: metricKey,
        source: '',
        time,
        value: null,
      });
    });
    return arr.sort((a: any, b: any) => String(a?.time).localeCompare(String(b?.time)));
  };

  const getMetricsList = (metricKey: string, list: any) => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    const arr: any = [];
    for (const n in list) {
      const objTemp = {
        cover: '',
        id: list[n]?.market,
        name: getCountryNameByCountryCode(regionOptions, list[n]?.market),
        history: getHistoryData(list[n]?.time_line || [], metricKey),
      };
      arr.push(objTemp);
    }
    return arr;
  };

  const lineSeriesData = useMemo(() => {
    const arrGameData: any = {};
    for (const n in segmentListCur) {
      arrGameData[segmentListCur[n]?.value] = getMetricsList(segmentListCur[n]?.value, lineDataCur);
    }
    return arrGameData;
  }, [lineDataCur, segmentListCur, firstWeekSinceReleaseDates]);

  return (
    <CommonVisualis
      noDecimalsLabel
      lineSeriesData={lineSeriesData}
      cardStatus={{
        isLoading: loading || trendLoading,
        isError: trendError,
        isNoData: shouldKeepYAxisWhenNoRank ? false : isLineNodata,
      }}
      entityType={entityType}
      cardTitle={
        appIds?.length > 1 ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {formatMessage({ id: `dbi_segment_rank_trend` })}
            <TipContext
              className="tip-text-hd dbi_pc_store_rank_tips"
              tipText={formatMessage({ id: 'dbi_info_rank_trend_mobile_tip_desc' })}
            />
          </div>
        ) : (
          formatMessage({ id: `dbi_segment_rank_trend` })
        )
      }
      segmentList={segmentListCur}
      pageId={`detailStorerank${isFreeCur ? 'free' : 'paid'}`}
      isHasSegmentChartIcon={true}
      chartType={'line'}
      statusHeight={406}
      isStoreRank={true}
      segmentValue={segmentValue}
      setSegmentValue={setSegmentValue}
      handleMetricChangeFun={handleMetricChangeFun}
    />
  );
};
export default RankTrendVisualis;
